import styled from 'styled-components';

import { Breakpoint, Color, FontWeight } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { Button } from '../button/button.component';
import { Image } from '../image/image.component';

import { ImageProps } from './artistTitle.types';

export const Container: StyledComponent<'div'> = styled.div`
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media ${Breakpoint.Mobile} {
    flex-direction: column;
  }
`;

export const ArtistDetails: StyledComponent<'div'> = styled.div`
  display: flex;
  align-items: center;

  @media ${Breakpoint.Mobile} {
    flex-direction: column;
  }
`;

export const LabelsContainer: StyledComponent<'div'> = styled.div`
  padding-right: 24px;

  @media ${Breakpoint.Mobile} {
    text-align: center;
    margin-bottom: 24px;
    padding: 0;
  }
`;

export const ImageContainer: StyledComponent<'div', ImageProps> = styled.div<ImageProps>`
  width: 96px;
  height: 96px;
  margin-right: 24px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border: ${({ $withImage }: ImageProps): string => !$withImage ? `1px solid ${Color.Gray300}` : 'none'};

  @media ${Breakpoint.Mobile} {
    margin-right: 0;
    margin-bottom: 24px;
  }
`;

export const ImageElement: StyledComponent<typeof Image> = styled(Image)`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
`;

export const Title: StyledComponent<'div'> = styled.div`
  font-size: 30px;
  font-weight: ${FontWeight.Medium};
  line-height: 38px;

  @media ${Breakpoint.Mobile} {
    margin-bottom: 4px;
  }
`;

export const Subtitle: StyledComponent<'div'> = styled.div`
  font-size: 18px;
  font-weight: ${FontWeight.Light};
  line-height: 26px;
  color: ${Color.Gray500};
`;

export const StyledButton: StyledComponent<typeof Button> = styled(Button)`
  flex-shrink: 0;

  @media ${Breakpoint.Mobile} {
    width: 100%;
  }
`;
